import React from 'react';
import Fade from 'react-reveal';
import PropTypes from 'prop-types';

const DURATION_TIME = 1000;
const Languages = ({ data }) => {
  if (!data) return null;

  const { title, description, languages } = data;

  const languagesView = languages.map((languageItem) => {
    const { language, country } = languageItem;
    const image = `images/languages/${country}.webp`;
    return (
      <div key={country} className="columns languages-item">
        <div className="item-wrap">
          <img alt={language} src={image} />
          <div style={{ textAlign: 'center' }}>
            <b>{language}</b>
          </div>
        </div>
      </div>
    );
  });

  return (
    <section id="languages">
      <Fade left duration={DURATION_TIME} distance="40px">
        <div className="row">
          <div className="twelve columns collapsed">
            <h1>{title}</h1>
            <p>{description}</p>

            <div id="languages-wrapper" className="bgrid-sixths s-bgrid-thirds cf">
              {languagesView}
            </div>
          </div>
        </div>
      </Fade>
    </section>
  );
};

Languages.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    languages: PropTypes.arrayOf(
      PropTypes.shape({
        language: PropTypes.string,
        country: PropTypes.string,
        translators: PropTypes.arrayOf(PropTypes.string),
      }),
    ),
  }).isRequired,
};

export default Languages;
